import { Badge } from '@frontend-platform/ui-lib/ui';
import { getBandDisplay } from './band-config';

interface BandBadgeProps {
  band: string | undefined;
}

// Renders a health/impact band as a colored outline badge. Falls back to a
// plain dash when the band is unknown — same behavior as aistudio's StatusBadge
// guard (`v-if="row.band && BAND_CONFIG[row.band]"`).
export function BandBadge({ band }: BandBadgeProps) {
  const display = getBandDisplay(band);
  if (!display) {
    return <span className="text-muted-foreground text-sm">{band ?? '-'}</span>;
  }
  return (
    <Badge variant="outline" className={display.classes}>
      {display.label}
    </Badge>
  );
}
